import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./DownloadPage.scss";

const InviteCodePage = () => {
    const { code } = useParams();
    const [deepLinkAttempted, setDeepLinkAttempted] = useState(false);

    useEffect(() => {
        if (!code) return;

        const deepLink = `backporch://InvitetionCodeUser?code=${encodeURIComponent(code)}`;

        window.location.href = deepLink;

        // After a short delay, mark attempt as done (app not installed fallback)
        const timer = setTimeout(() => {
            setDeepLinkAttempted(true);
        }, 1500);

        return () => clearTimeout(timer);
    }, [code]);

    return (
        <div className="DownloadPage">
            <div className="DownloadPage__card">

                <div className="DownloadPage__logo">
                    <img src="/logo.svg" alt="Backporch" />
                </div>

                <div className="DownloadPage__divider" />

                {!deepLinkAttempted ? (
                    <div className="DownloadPage__redirecting">
                        <div className="DownloadPage__spinner" />
                        <p className="DownloadPage__redirect-text">
                            Opening Backporch...
                        </p>
                        <p className="DownloadPage__redirect-sub">
                            You'll be redirected to the app automatically.
                        </p>
                    </div>
                ) : (
                    <>
                        <p className="DownloadPage__tagline">Don't have the app yet?</p>
                        <p className="DownloadPage__sub">
                            Download Backporch to accept your invitation.
                        </p>
                        <div className="DownloadPage__badges">
                            <a
                                href={process.env.REACT_APP_IOS_STORE_URL}
                                target="_blank"
                                rel="noreferrer"
                                className="DownloadPage__badge-link"
                            >
                                <img
                                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                                    alt="Download on the App Store"
                                />
                            </a>
                            <a
                                href={process.env.REACT_APP_ANDROID_STORE_URL}
                                target="_blank"
                                rel="noreferrer"
                                className="DownloadPage__badge-link"
                            >
                                <img
                                    src="/google-play-badge.png"
                                    alt="Get it on Google Play"
                                    className="DownloadPage__badge-android"
                                />
                            </a>
                        </div>
                    </>
                )}

            </div>
        </div>
    );
};

export default InviteCodePage;